<div class="avatar">
  @if (initials()) {
    <span class="initials">{{ initials() }}</span>
  }
</div>
